import React, { Component } from 'react';
import { API_ENDPOINT, JOURNAL_API, JOURNAL_DASHBOARD } from '../../../constants';
import moment from 'moment';

import ListBuilder from '../../../components/listBuilder';
import Isvg from 'react-inlinesvg';
import copyIcon from "../../../assets/svg/copy-icon.svg";
import viewIcon from '../../../assets/svg/eye.svg'
import editIcon from '../../../assets/svg/edit.svg';
import addIcon from '../../../assets/svg/add-icon.svg';
import deleteIcon from '../../../assets/svg/garbage.svg';
import LockIcon from '../../../assets/svg/lock.svg';
import pdfIcon from '../../../assets/svg/save-as-pdf.svg';

import noNotifications from '../../../assets/svg/no-notif.svg';
import conditionLinkIcon from '../../../assets/svg/conditional-link-icon.svg'
import lockSvg from '../../../assets/svg/lock.svg';
import infoIcon from "../../../assets/svg/link-new-tab.svg";
import linkSvg from '../../../assets/svg/users.svg';
import paymentIcon from '../../../assets/svg/payment-icon.svg';
import cameraIcon from '../../../assets/svg/camera.svg';
import exportIcon from '../../../assets/svg/export.svg';

import {
	updateParamsHelper,
	getParamsFromURL,
} from '../../../helpers/custom.helper';
import PreviewModal from '../../../components/previewModal';
import JournalTemplatesModal from './journalTemplates.modal';
import JournalPdf from './journal-pdf';
import { Button, Col, Container, Input, Label, Modal, ModalBody, ModalFooter, Row } from 'reactstrap';
import InfoModal from '../../../components/infoModal';
import HealthFlagsTab from './healthFlags.tab';
import VitalLogsTab from './vitalLogs.tab';
import VaccinationsTab from './vaccinations.tab';
import { calculateAgeFromSSN, getAgeFromDobOrSSN } from '../helper';
import CreatePayment from '../../payments/components/createPayment';
import ErrorModal from '../../../components/errorModal';
import { isClinicAdminChecker } from '../../../helpers/journal.helper';
import PatientPreviousRecordsTab from './previousRecords.tab';

function parseText(response) {
	return response.text().then(text => {
		return {
			result: text,
			status: response.status
		}
	})
}
export default class JournalNotesTab extends Component {
	constructor(props) {
		super(props)
		this.state = {
			_isMounted: false,
			journalTemplatesModal: false,
			journalFormBuilder: false,
			journalFormBuilderNew: false,
			preview: false,
			total: 0,
			params: {
				entries: 10,
				page: 0,
				sortField: 'initialCreatedAt',
				sortType: 1,
				filter: '',
			},
			filter: null,
			loading: true,
			journalNotes: [],
			error: null,
			modified: 'Not modified'.translate(this.props.lang),
			journalDeleteNoteModal: null,
			pdfModal: false,
			pdfLink: '',
			tabIndex: 1,
			journalSSOToken: null,
			sortField: 'initialCreatedAt',
			allowRowClick: true,
			EHR_noteEditedButNotSaved: false,
			journalFormBuilderNew: false,
			journalFormBuilder: false,
			clinicUserPermissions: null
		};
		this.wholeRowClickable = true;
	}

	get = async () => {
		if (!this.state._isMounted) return;

		this.setState({
			loading: true,
			journalNotes: [],
			modified: 'Not modified'.translate(this.props.lang),
		});

		try {
			const response = await fetch(
				`${API_ENDPOINT}/users/users/patient/journalNotes/get`,
				{
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						Authorization: `Bearer ${localStorage.getItem('authToken')}`,
					},
					body: JSON.stringify({
						groupAlias: localStorage.getItem('groupAlias'),
						groupId: this.props._groupId || null,
						patientId: this.props.patientId,
						total: this.state.total,
						entries: this.state.params?.entries,
						page: this.state.params?.page,
						sortField: this.state.sortField,
						sortType: this.state.sortField === 'initialCreatedAt' ? -1 : this.state.params?.sortType,
						filter: this.state.params?.filter,
					}),
				}
			);

			const { data } = await response.json();

			if (data?.items) {
				const newState = {
					loading: false,
					journalNotes: data?.items,
					total: data?.total,
				};

				if (data?.tsModified) {
					const modified = this.props.getStringDateTs?.(
						data?.tsModified,
						this.props.dateFormat
					);
					if (modified) newState.modified = modified.translate(this.props.lang);
				}

				this.setState(newState);
			} else {
				const errState = {
					loading: false,
					modified: 'Not modified'.translate(this.props.lang),
				};

				if (data?.error) {
					errState.error = data.error;
				}

				this.setState(errState);
			}
		} catch (err) {
			this.setState({
				loading: false,
				error: err?.message || 'Error fetching journal notes',
			});
		}
	};

	getClinicUserData = async () => {
		try {
			const response = await fetch(`${API_ENDPOINT}/journal-curoflow/clinic-user/get-permission`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${localStorage.getItem('authToken')}`,
				},
				body: JSON.stringify({ groupId: this.props._groupId }),
			});

			const result = await response.json();

			this.setState({ clinicUserPermissions: result?.data?.permissions });
		} catch (err) {
			console.log('Err get clinic user data', err);
		}

	}

	deleteJournalNote = async (id, referralId) => {
		if (!id) return;

		try {
			const response = await fetch(
				`${API_ENDPOINT}/users/users/patient/journalNotes/${id}`,
				{
					method: "DELETE",
					headers: {
						"Content-Type": "application/json",
						Authorization: `Bearer ${localStorage.getItem("authToken")}`,
					},
					body: JSON.stringify({
						groupId: this.props.selectedGroup || null,
						departmentId: this.props.selectedClinic || null,
					}),
				}
			);

			const data = await response.json();

			if (data.result?.error) {
				this.setState({ error: data.result.error });
			} else {
				if (referralId) {
					await fetch(
						`${API_ENDPOINT}/users/users/patient/journalNotes/${id}/referral/removeJournalNoteFromReferral/${referralId}`,
						{
							method: "PATCH",
							headers: {
								"Content-Type": "application/json",
								Authorization: `Bearer ${localStorage.getItem("authToken")}`,
							},
							body: JSON.stringify({
								groupId: this.props.selectedGroup || null,
								departmentId: this.props.selectedClinic || null,
							}),
						}
					);
				}

				await this.get();
				this.setState({
					journalDeleteNoteModal: null,
				});
			}

		} catch (err) {
			console.error("Delete note fetch error", err);
			return null;
		}
	}

	// checkPermission = () => {
	// 	let hasPermission = false;

	// 	const clinic = this.props.uData?.clinicGroups?.find(c => c._id === this.props.selectedGroup);

	// 	const groupPermissionsUser = this.props.uData?.groupPermissionsUser;
	// 	const adminPermissionId = this.props.uData?.permissions?.clinicAdmin;
	// 	const doctorPermissionId = this.props.uData?.permissions?.doctor;

	// 	const isClinicAdmin = groupPermissionsUser?.[this.props.selectedGroup]?.[this.props.selectedClinic]?.indexOf(adminPermissionId) !== -1 ? true : false;
	// 	const isDoctor = groupPermissionsUser?.[this.props.selectedGroup]?.[this.props.selectedClinic]?.indexOf(doctorPermissionId) !== -1 ? true : false;

	// 	if (isClinicAdmin && clinic?.journalCuroflow?.allowAdminUnlockSignedNotes) {
	// 		hasPermission = true;
	// 	} else if (!isClinicAdmin && isDoctor && clinic?.journalCuroflow?.allowHealthcareProviderUnlockSignedNotes) {
	// 		hasPermission = true;
	// 	}

	// 	return hasPermission;
	// }

	getJournalSSOToken = async (type = "notes") => {
		try {
			const response = await fetch(
				`${API_ENDPOINT}/users/users/patient/journal/getJournalTokenSSO`,
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						Authorization: `Bearer ${localStorage.getItem("authToken")}`,
					},
					body: JSON.stringify({ type, groupId: this.props.selectedGroup || null }),
				}
			);

			const data = await response.json();

			if (!response.ok || data?.error) {
				throw new Error(data?.error || "SSO token error");
			}

			return data;
		} catch (err) {
			console.error("SSO token fetch error", err);
			return null;
		}
	};

	copyJournalNote = async (id) => {
		if (!id) return;

		try {
			const response = await fetch(
				`${API_ENDPOINT}/users/users/patient/journalNotes/copy/${id}`,
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						Authorization: `Bearer ${localStorage.getItem("authToken")}`,
					},
					body: JSON.stringify({
						groupId: this.props.selectedGroup || null,
						departmentId: this.props.selectedClinic || null,
					}),
				}
			);

			const data = await response.json();
			if (!response.ok || data?.error) {
				throw new Error(data?.error || "Copy note error");
			}

			return data?.data;
		} catch (err) {
			console.error("Copy note fetch error", err);
			return null;
		}
	}

	componentDidMount() {
		this.state._isMounted = true;

		this.getClinicUserData();

		window.addEventListener("message", this.handleIframeReady);
		window.addEventListener("message", this.handleIframeCloseModal);
		window.addEventListener("message", this.handleIframeResize);
		window.addEventListener("message", this.handleUpdateStateNoteEditedButNotSaved);

		const urlParams = getParamsFromURL();

		const newParams = {
			...this.state.params,
			entries: urlParams.entries,
			filter: urlParams.filter,
		};

		this.setState({ params: newParams }, () => {
			if (this.props.patient) {
				this.setState({ patient: this.props.patient });
			}
			if (this.props.journalNotes) {
				this.setState({
					loading: false,
					journalNotes: this.props.journalNotes,
				});
			} else {
				// this.setState({loading: false, journalNotes: [DUMMY_OBJECT_FROM_JOURNAL_DEV]}) // DELETE THIS LATER
				this.get();
			}
		});
	}

	componentDidUpdate(prevProps, prevState) {
		if (
			prevProps.patientId !== this.props.patientId ||
			prevProps._groupId !== this.props._groupId ||
			prevProps.view !== this.props.view
		) {
			this.setState({
				loading: true,
				journalNotes: [],
				modified: 'Not modified'.translate(this.props.lang),
			});

			this.get();
		}
		if (
			this.props.isConsentGrantedAndActive !== prevProps.isConsentGrantedAndActive ||
			this.props.isConsentActive !== prevProps.isConsentActive
		) {
			this.sendPermissionsToIframe();
		}

		if (this.state.EHR_noteEditedButNotSaved !== prevState.EHR_noteEditedButNotSaved || this.state.journalFormBuilderNew !== prevState.journalFormBuilderNew) {
			this.sendPermissionsToIframe();
			if ((this.state.journalFormBuilder && this.state.EHR_noteEditedButNotSaved) || this.state.journalFormBuilderNew) {
				this.props.groupSettingsChanged()
				this.props.changeLinkModalState(true)
				this.setState({
					isJournalNoteActive: true
				})
			}

			if ((!this.state.journalFormBuilder || !this.state.EHR_noteEditedButNotSaved) && !this.state.journalFormBuilderNew) {
				this.props.abortAction()
				this.props.changeLinkModalState(false)
				this.setState({
					isJournalNoteActive: false
				})
			}
		}

		if (this.props.isConsentGrantedAndActive !== prevProps.isConsentGrantedAndActive || this.props.isConsentActive !== prevProps.isConsentActive) {
			this.get();
		}
		if (prevState.tabIndex !== this.state.tabIndex && this.state.tabIndex !== 1 && (this.state.journalFormBuilder || this.state.journalFormBuilderNew)) {
			this.setState({
				journalFormBuilder: false,
				journalFormBuilderNew: false,
			});
		}

		if (this.state.sortField && prevState.sortField !== this.state.sortField) {
			this.get();
		}
	}

	componentWillUnmount() {
		this.state._isMounted = false;
		window.removeEventListener("message", this.handleIframeReady);
		window.removeEventListener("message", this.handleIframeCloseModal);
		window.removeEventListener("message", this.handleIframeResize);
		window.removeEventListener("message", this.handleUpdateStateNoteEditedButNotSaved);
	}

	handleUpdateStateNoteEditedButNotSaved = async (event) => {
		if (event.data?.type === "IFRAME_V1_UPDATE_STATE_NOTE_EDITED_BUT_NOT_SAVED" &&
			(event.data?.payload?.status === true || event.data?.payload?.status === false)) {
			this.setState({ EHR_noteEditedButNotSaved: event.data?.payload?.status || false });
		}
	}

	// always copy - paste these updateSort, updateParams, updateMultipleParams
	updateSort = (field, type) => {
		updateParamsHelper(this, { sortField: field, sortType: type });
	};

	updateParams = (name, value, restart = false) => {
		updateParamsHelper(this, { [name]: value }, restart);
	};

	updateMultipleParams = (fields, restart = false) => {
		updateParamsHelper(this, fields, restart);
	};

	checkDisableEdit = (item, skipLastSignedCheck) => {
		const clinic = this.props.uData?.clinicGroups
			?.find(c => c._id === this.props.selectedGroup);

		const CONSENT_ACTIVE = this.props.isConsentActive;
		const CONSENT_SWITCH_ON = this.props.isConsentGrantedAndActive;

		const groupPermissionsUser = this.props.uData?.groupPermissionsUser;
		const adminPermissionId = this.props.uData?.permissions?.admin;
		const schedulerPermissionId = this.props.uData?.permissions?.scheduler;

		const isAdmin = groupPermissionsUser?.[this.props.selectedGroup]?.[this.props.selectedClinic]?.indexOf(adminPermissionId) !== -1 || groupPermissionsUser?.[this.props.selectedGroup]?.[this.props.selectedClinic]?.indexOf(schedulerPermissionId) !== -1 ? true : false;


		const ALLOW_HEALTHCARE_PROVIDER_UNLOCK_SIGNED_NOTES =
			clinic?.journalCuroflow?.allowHealthcareProviderUnlockSignedNotes;

		const ALLOW_ADMIN_UNLOCK_SIGNED_NOTES =
			clinic?.journalCuroflow?.allowAdminUnlockSignedNotes;

		const JOURNAL_NOTE = item ? item : this.state.journalFormBuilder;

		let disableEdit = false;

		if (!JOURNAL_NOTE) {
			disableEdit = false;
		} else {
			// if (CONSENT_ACTIVE && CONSENT_SWITCH_ON) {
			// 	disableEdit = true;
			// } else if (!CONSENT_ACTIVE || (CONSENT_ACTIVE && !CONSENT_SWITCH_ON)) {
			if (ALLOW_HEALTHCARE_PROVIDER_UNLOCK_SIGNED_NOTES === false && JOURNAL_NOTE?.isSigned?.status === true && !isAdmin) {
				disableEdit = true;
			} else if (ALLOW_ADMIN_UNLOCK_SIGNED_NOTES === false && JOURNAL_NOTE?.isSigned?.status === true && isAdmin && JOURNAL_NOTE?.doctorData?.doctorId !== this.props.uData?.journalCuroflow?.[this.props.selectedGroup]?.id) {
				disableEdit = true;
			} else if (JOURNAL_NOTE?.isSigned?.status === false && JOURNAL_NOTE?.doctorData?.doctorId !== this.props.uData?.journalCuroflow?.[this.props.selectedGroup]?.id) {
				disableEdit = true;
			} else {
				disableEdit = false;
			}

			if (ALLOW_HEALTHCARE_PROVIDER_UNLOCK_SIGNED_NOTES && JOURNAL_NOTE?.doctorData?.doctorId !== this.props.uData?.journalCuroflow?.[this.props.selectedGroup]?.id && !isAdmin) {
				disableEdit = true
			}

			if (isAdmin && JOURNAL_NOTE?.doctorData?.doctorId === this.props.uData?.journalCuroflow?.[this.props.selectedGroup]?.id) {
				disableEdit = false
			}
			// }
		}

		// if (!skipLastSignedCheck) {
		// 	if (JOURNAL_NOTE?.isSigned?.status === true) {
		// 		disableEdit = true;
		// 	}
		// }

		if (!this.state.clinicUserPermissions?.write?.journal_notes) {
			disableEdit = true;
		}

		return disableEdit;
	};

	sendPermissionsToIframe = () => {
		const iframe = document.getElementById("journalNotesTabIframe");
		if (!iframe || !iframe.contentWindow) return;

		const disableEdit = this.checkDisableEdit();

		iframe.contentWindow.postMessage({
			type: "UPDATE_PERMISSIONS",
			payload: { disableEdit }
		}, JOURNAL_DASHBOARD);
	}

	handleIframeReady = (event) => {
		// if (event.origin !== JOURNAL_DASHBOARD) return;
		if (!this.state._isMounted) return;

		if (event.data.type === "IFRAME_READY_V1_JOURNAL_TEMPLATES_BUILDER") {
			const iframe = document.getElementById("journalNotesTabIframe");
			if (!iframe || !iframe.contentWindow) return;

			const lang = this.props?.lang || "en";
			const countryTwoLetter = this.props?.countryTwoLetter || localStorage.getItem('countryTwoLetter');
			const clinic = this.props.uData?.clinicGroups?.find(c => c._id === this.props.selectedGroup);
			const department = this.props.selectedClinic;
			const journalClinicId = clinic?.journalCuroflow?.clinicId;
			const journalDoctorId = this.props.uData?.journalCuroflow?.[String(this.props.selectedGroup)]?.id;
			const journalPatientId = this.props.patient?.journalId;

			const JOURNAL_NOTE = this.state.journalFormBuilder;

			let disableEdit = false;

			// permissions
			if (!JOURNAL_NOTE) {
				disableEdit = false;
			} else {
				disableEdit = this.checkDisableEdit();
			}

			const isAdmin = isClinicAdminChecker(this.props);

			const payload = {
				type: "APP_DATA",
				payload: { curoflowV1: true, clinicId: journalClinicId, disableEdit: disableEdit, doctorId: journalDoctorId, patientId: journalPatientId, departmentId: department, lang: lang, countryTwoLetter: countryTwoLetter, isOnPatientPage: true, isClinicAdmin: isAdmin }
			};
			iframe.contentWindow.postMessage(payload, `${JOURNAL_DASHBOARD}`);
			// iframe.contentWindow.postMessage(payload, "http://localhost:3000");
		}
	};

	exportPdfJournal = async () => {
		const response = await fetch(`${API_ENDPOINT}/users/users/patient/journalNotes/export-pdf`, {
			method: 'post',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${localStorage.getItem('authToken')}`,
			},
			body: JSON.stringify({ groupId: this.props.selectedGroup || null, patientId: this.props.patientId, lang: this.props.lang || "en" }),
			responseType: 'blob'
		})

		const blob = await response.blob();

		const url = window.URL.createObjectURL(blob);
		window.open(url, '_blank');

		setTimeout(() => window.URL.revokeObjectURL(url), 10000);
	}

	handleIframeCloseModal = (event) => {
		// if (event.origin !== JOURNAL_DASHBOARD) return;
		if (event.data.type === "IFRAME_CLOSE_V1_JOURNAL_NOTES_JOURNAL_TEMPLATES_MODAL") {
			this.closeModal();
			this.get();
		}
	}


	handleIframeResize = (event) => {
		// if (event.origin !== JOURNAL_DASHBOARD) return;
		if (event.data?.type === "IFRAME_V1_JOURNAL_TEMPLATES_BUILDER_HEIGHT_CHANGED") {
			const iframe = document.getElementById("journalNotesTabIframe");
			if (iframe) {
				iframe.style.height = `${event.data?.payload?.height ?? 1000}px`;
			}
		}
	};

	signJournalNote = async (item, status) => {
		await fetch(`${API_ENDPOINT}/users/users/patient/journalNotes/sign`, {
			method: 'PATCH',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${localStorage.getItem('authToken')}`,
			},
			body: JSON.stringify({
				status,
				groupId: this.props.selectedGroup || null,
				journalNoteId: item._id,
				patientId: this.props.patientId,
				journalDate: this.state.journalDate ?? this.formatJournalNoteDateTimeLocal()
			})
		}).then(parseText).then(({ status, result }) => {
			const res = JSON.parse(result);
			if (res.error) {
				this.setState({ error: res.error });
			}
		});

		this.setState({
			infoSignModal: false,
			infoUnsignModal: false,
			journalDate: null
		})

		// await this.get();
	}

	closeModal = () => {
		this.setState({
			journalTemplatesModal: null,
			journalFormBuilder: null,
			journalFormBuilderNew: null,
			pdfModal: false,
			infoSignModal: false,
			infoUnsignModal: false
		})
	}

	formatJournalNoteDateTimeLocal = (value) => {
		if (!value) {
			const d = new Date();
			const pad = n => String(n).padStart(2, '0');

			return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
		}

		const REGEX = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/;

		if (!REGEX.test(value)) {
			throw new Error('Invalid date format. Expected YYYY-MM-DD HH:mm');
		}

		return value.replace(' ', 'T');
	};
	openJournalNote = async (item) => {
		if (this.wholeRowClickable === false) return;

		if ((this.state.journalFormBuilder && this.state.journalFormBuilder._id === item._id) || this.state.journalFormBuilderNew) {
			if (!this.state.isJournalNoteActive) {
				this.setState({
					journalFormBuilder: null,
					journalFormBuilderNew: null
				});
			} else {
				this.setState({
					isJournalNoteActiveChange: 'close journal note iframe'
				});
			}
			return;
		}

		const { data: tokenData } = await this.getJournalSSOToken("notes");
		if (!tokenData?.data?.token) return;

		this.setState({
			journalSSOToken: tokenData.data.token,
			journalFormBuilder: item,
			journalFormBuilderNew: null
		}, () => {
			this.sendPermissionsToIframe();
		});
	}


	render() {
		let params = this.state.params;

		const clinic = this.props.uData?.clinicGroups?.find(c => c._id === this.props.selectedGroup);

		return (
			<div>

				<Container fluid >
					<Row>
						<Col lg="8">
							<div className="patient-main-info">
								<div className="patient-main-info-container">
									<h6>{'Patient'.translate(this.props.lang)}</h6>
									<div className="patient-main-right">
										{
											!this.state.patient?.phone && !this.state.patient?.email ?
												<div className='patient-no-notif'>
													<Isvg src={noNotifications} width={20} height={20} />
													<div>
														{'Phone and email not registered'.translate(this.props.lang)}
													</div>
													<div className='tooltip-text'>{'No contact details registered. Add information in the patient profile to send notifications.'.translate(this.props.lang)}</div>
												</div>
												:
												null
										}
										{
											this.props.isConditionalLinksEnabled ?
												<button className="patient-button-2" onClick={() => {
													// this.setState({ conditionalLinkModal: JSON.parse(JSON.stringify(this.state.patient)) });
													this.props.openConditionalLinksModal();
												}}>
													<div className='button-elements-tooltip'>
														<Isvg src={conditionLinkIcon} />
														<div className='tooltip-text'>{'Custom patient content'.translate(this.props.lang)}</div>
													</div>

												</button>
												:
												null
										}
										{this.props.clinicGroupSettings?.twoFactorAuthentication ? <button className="patient-button-2" onClick={() => {
											const age = getAgeFromDobOrSSN(this.state.patient?.dateOfBirth, this.state.patient?.socialSecurityNumber);

											let isChild = false;

											if (typeof age === 'number' && this.props.AGE_LIMIT && age < this.props.AGE_LIMIT) isChild = true;

											this.props.openTwoFactorAuthenticationModal(isChild);
										}}>
											<div className='button-elements-tooltip'>
												<Isvg src={lockSvg} width={24} height={24} />
												<div className='tooltip-text'>{'Two factor authentication'.translate(this.props.lang)}</div>
											</div>

										</button> : null}
										<button className="patient-button-2" onClick={() => {
											// this.setState({
											// 	linkedAccoutns: true
											// })
											this.props.openLinkedAccountsModal();
										}}>
											<div className='button-elements-tooltip'>
												<Isvg src={linkSvg} />
												<div className='tooltip-text'>{'Linked accounts'.translate(this.props.lang)}</div>
											</div>

										</button>
									</div>
								</div>

								<div>
									<div>
										<p className="patient-name">{this.state.patient && this.state.patient.userLevel && this.state.patient.userData.name}	</p>
										<p className="patient-number">{this.state.patient && this.state.patient.socialSecurityNumber}	</p>
										<p className="patient-address">{this.state.patient && this.state.patient.userData && this.state.patient.userData.sex ? this.state.patient.userData.sex == 'male' ? 'Male'.translate(this.props.lang) : this.state.patient.userData.sex == 'Boy' ? 'Boy'.translate(this.props.lang) : this.state.patient.userData.sex == 'Girl' ? 'Girl'.translate(this.props.lang) : this.state.patient.userData.sex == 'female' ? 'Female'.translate(this.props.lang) : this.state.patient.userData.sex : ''}{this.state.patient && this.state.patient.userData && this.state.patient.userData.sex && this.state.patient.socialSecurityNumber ? ', ' : ''}{this.state.patient && this.state.patient.socialSecurityNumber ? (calculateAgeFromSSN(this.state.patient.socialSecurityNumber, this.props.country) + ' ' + (calculateAgeFromSSN(this.state.patient.socialSecurityNumber, this.props.country) == 1 ? 'year'.translate(this.props.lang) : 'years'.translate(this.props.lang))) : ''}</p>
										{
											this.props.patientInfoSettings?.isCustomIdEnabled ?
												<p className='patient-customId'>{this.props.patientInfoSettings?.customIdLabel ? this.props.patientInfoSettings?.customIdLabel : 'Custom id'.translate(this.props.lang)}: {this.state.patient?.customId?.[this.props.selectedGroup] ?? 'N/A'}
													<div className='button-elements-tooltip' style={{ cursor: 'pointer' }} onClick={() => {
														this.props.openCustomIdModal();
													}}>
														<Isvg src={editIcon} width={20} height={20} />
														<div className='tooltip-text'>{'Edit'.translate(this.props.lang)}</div>
													</div>
												</p>
												:
												null
										}
									</div>
									<div className={this.state.patient?.patientInfo?.[this.props.selectedGroup]?.infection || this.state.patient?.patientInfo?.[this.props.selectedGroup]?.allergies || this.state.patient?.patientInfo?.[this.props.selectedGroup]?.customField1 || this.state.patient?.patientInfo?.[this.props.selectedGroup]?.customField2 ? "patient-notes-exists" : "patient-notes"}>
										<button onClick={() => {
											// this.setState({
											// 	formInfo: {
											// 		infection: this.state.patient && this.state.patient.patientInfo && this.state.patient.patientInfo[this.props.selectedGroup] && this.state.patient.patientInfo[this.props.selectedGroup].infection ? this.state.patient.patientInfo[this.props.selectedGroup].infection : '',
											// 		allergies: this.state.patient && this.state.patient.patientInfo && this.state.patient.patientInfo[this.props.selectedGroup] && this.state.patient.patientInfo[this.props.selectedGroup].allergies ? this.state.patient.patientInfo[this.props.selectedGroup].allergies : '',
											// 		tsModified: this.state.patient && this.state.patient.patientInfo && this.state.patient.patientInfo[this.props.selectedGroup] && this.state.patient.patientInfo[this.props.selectedGroup].tsModified ? this.state.patient.patientInfo[this.props.selectedGroup].tsModified : null,
											// 		modifiedByUsername: this.state.patient && this.state.patient.patientInfo && this.state.patient.patientInfo[this.props.selectedGroup] && this.state.patient.patientInfo[this.props.selectedGroup].modifiedByUsername ? this.state.patient.patientInfo[this.props.selectedGroup].modifiedByUsername : null,
											// 		customField1: this.state.patient?.patientInfo?.[this.props.selectedGroup]?.customField1 || '',
											// 		customField2: this.state.patient?.patientInfo?.[this.props.selectedGroup]?.customField2 || ''
											// 	}
											// })
											this.props.openImportantInfoModal()
										}}>
											<div className='button-elements-tooltip'>
												<Isvg src={infoIcon} />
												<div className='tooltip-text' style={{ minWidth: 180, bottom: 35 }}>{'Important information'.translate(this.props.lang)}</div>
											</div>
										</button>
									</div>
								</div>

							</div>


						</Col>
						<Col lg="4" className="patient-payments-button-wrap">
							{
								this.props.EXTENDED_PAYMENT_MANAGEMENT && this.props.userPaymentPermissions?.createNewPayments ?
									<div className='start-video-button-wrap'>
										<Button color="primary" onClick={() => {
											this.setState({ createPaymentModal: true })
											// this.props.createPaymentModalOpenHandler();
										}}>
											{/* <Isvg src={paymentIcon} /> */}
											{'Create payment'.translate(this.props.lang)}
										</Button>
										<div className='fake-svg-26' />
									</div>
									:
									null
							}
							{/* {
								this.props.journalCuroflowEnable && this.props.uData?.journalCuroflow?.[this.props.selectedGroup]?.active ?
									<div className='start-video-button-wrap'>

										<Button color={this.props.isConsentActive ? "success" : "primary"} onClick={() => {
											if (!this.props.isConsentActive)
												this.props.toggleJournalRequestConsentForm();
										}}>
											{this.props.isConsentActive ? 'Consent granted'.translate(this.props.lang) : 'Request consent'.translate(this.props.lang)}
										</Button>
										<div className='fake-svg-26' />
									</div>
									: null
							} */}
							<div className='start-video-button-wrap'>
								<Button color="primary" onClick={() => {
									if (!this.state.isJournalNoteActive) {
										this.props[0].history.push(`/my-data/clinic/payments?entries=10&sortField=timestamp&sortType=-1&filter=${this.state.patient.socialSecurityNumber}`)
									} else {
										this.setState({
											isJournalNoteActiveChange: 'see payments'
										})
									}
								}}>
									<Isvg src={paymentIcon} />
									{'See payments'.translate(this.props.lang)}
								</Button>
								<div className='fake-svg-26' />
							</div>

							{
								this.props._videoButtonEnabled && (this.props.chatConversation || this.props.chatId) && this.props.doctorCanStartVideoCall ?
									<div className='start-video-button-wrap'>
										<Button onClick={() => {
											if (!this.state.isJournalNoteActive) {
												this.props.startVideoCallHandler();
											} else {
												this.setState({
													isJournalNoteActiveChange: 'start video call'
												})
											}
										}}>
											<Isvg src={cameraIcon} />
											{'Start video chat'.translate(this.props.lang)}
										</Button>
										<div className='button-elements-tooltip'>
											<Isvg src={infoIcon} width={26} height={26} />
											<div className='tooltip-text'>{`Note that if patient hasn't yet signed in and completed their account, the call might not get through. You can make sure the patient is signed in by sending a chat message. You can also activate the notification "Video call started" to send a video-link to the patient.`.translate(this.props.lang)}</div>
										</div>
									</div> : null
							}

						</Col >
					</Row >
					<Row>
						<Col lg="12">
							<div className='journal-note-active-button'  >

								<Button
									className={
										"tab-button " +
										(this.state.tabIndex === 1 ? "active-button " : "") +
										(!this.state.clinicUserPermissions?.read?.journal_notes ? "disabled-tab" : "")
									}
									onClick={() => {
										if (!this.state.isJournalNoteActive) {
											this.setState({ tabIndex: 1 })
										} else {
											this.setState({
												isJournalNoteActiveChange: 'tab 1'
											})
										}
									}}
									disabled={!this.state.clinicUserPermissions?.read?.journal_notes}
								>
									{"Journal Notes".translate(this.props.lang)}
								</Button>

								<Button
									className={
										"tab-button " +
										(this.state.tabIndex === 2 ? "active-button " : "") +
										(!this.state.clinicUserPermissions?.read?.patient_health_flags ? "disabled-tab" : "")
									}
									onClick={() => {
										if (!this.state.isJournalNoteActive) {
											this.setState({ tabIndex: 2 })
										} else {
											this.setState({
												isJournalNoteActiveChange: 'tab 2'
											})
										}
									}}
									disabled={!this.state.clinicUserPermissions?.read?.patient_health_flags}
								>
									{"Health flags".translate(this.props.lang)}
								</Button>

								<Button
									className={
										"tab-button " +
										(this.state.tabIndex === 3 ? "active-button " : "") +
										(!this.state.clinicUserPermissions?.read?.patient_vital_logs ? "disabled-tab" : "")
									}
									onClick={() => {
										if (!this.state.isJournalNoteActive) {
											this.setState({ tabIndex: 3 })
										} else {
											this.setState({
												isJournalNoteActiveChange: 'tab 3'
											})
										}
									}}
									disabled={!this.state.clinicUserPermissions?.read?.patient_vital_logs}
								>
									{"Vital logs".translate(this.props.lang)}
								</Button>

								<Button
									className={
										"tab-button " +
										(this.state.tabIndex === 4 ? "active-button " : "") +
										(!this.state.clinicUserPermissions?.read?.patient_vaccination ? "disabled-tab" : "")
									}
									onClick={() => {
										if (!this.state.isJournalNoteActive) {
											this.setState({ tabIndex: 4 })
										} else {
											this.setState({
												isJournalNoteActiveChange: 'tab 4'
											})
										}
									}}
									disabled={!this.state.clinicUserPermissions?.read?.patient_vaccination}
								>
									{"Vaccinations".translate(this.props.lang)}
								</Button>

								{clinic?.patientPreviousRecords === true && (
									<Button
										className={
											"tab-button " +
											(this.state.tabIndex === 5 ? "active-button " : "") +
											(!this.state.clinicUserPermissions?.read?.patient_previous_records ? "disabled-tab" : "")
										}
										onClick={() => {
											if (!this.state.isJournalNoteActive) {
												this.setState({ tabIndex: 5 })
											} else {
												this.setState({
													isJournalNoteActiveChange: 'tab 5'
												})
											}
										}}
										disabled={!this.state.clinicUserPermissions?.read?.patient_previous_records}
									>
										{"Previous Records".translate(this.props.lang)}
									</Button>
								)}


							</div>
						</Col>
						{
							this.state.tabIndex == 1 && <Col lg={12} md={12} sm={12} xs={12} >
								<Row>
									<Col lg={12} md={12} sm={12} xs={12}>
										<div className='panel-header d-flex align-items-center justify-content-end'>
											<h5 className='component-header me-auto'>
												{'Journal Notes'.translate(this.props.lang)}
											</h5>

											<button
												disabled={!this.state.clinicUserPermissions?.read?.journal_notes}
												className='btn add-button me-2'
												onClick={() => {
													this.exportPdfJournal();
												}}
											>
												<Isvg src={exportIcon} /> {'Export'.translate(this.props.lang)}
											</button>

											<button
												className='btn add-button'
												disabled={!this.state.clinicUserPermissions?.write?.journal_templates}
												onClick={() => {
													if (!this.state.isJournalNoteActive) {
														this.setState({
															journalTemplatesModal: true,
															journalFormBuilderNew: true,
															journalFormBuilder: null
														}, () => {
															this.sendPermissionsToIframe();
														});
													} else {
														this.setState({
															isJournalNoteActiveChange: 'new clinical note'
														})
													}

												}}
											>
												<Isvg src={addIcon} /> {'New clinical note'.translate(this.props.lang)}
											</button>
										</div>
									</Col>

									{
										<Col lg={7} md={12} sm={12} xs={12} style={{ display: this.state.journalFormBuilder || this.state.journalFormBuilderNew ? "block" : "none", borderRight: this.state.journalFormBuilder || this.state.journalFormBuilderNew ? '2px solid #e6edf5' : 'unset' }} >
											{this.state.journalFormBuilder?._id ? (
												<iframe
													id="journalNotesTabIframe"
													src={`${JOURNAL_DASHBOARD}/journal/templates/builder/${this.state.journalFormBuilder?.templateData?.templateId}/${this.state.journalFormBuilder?._id}?token=${this.state.journalSSOToken}`}
													style={{ width: '100%', maxHeight: '85vh', border: 'none', display: 'block' }}
												/>
											) : this.state.journalFormBuilderNew?._id ? (
												<iframe
													// id="journalTemplatesModalIframe"
													id="journalNotesTabIframe"
													src={`${JOURNAL_DASHBOARD}/journal/templates/builder/${this.state.journalFormBuilderNew?._id}/new?token=${this.state.journalSSOToken}`}
													style={{ width: '100%', maxHeight: '85vh', border: 'none', display: 'block' }}
												/>
											) : null}
										</Col>
									}

									<Col lg={this.state.journalFormBuilder?._id || this.state.journalFormBuilderNew?._id ? 5 : 12} md={12} sm={12} xs={12} >
										<ListBuilder
											lang={this.props.lang}
											loading={this.state.loading}
											total={this.state.total}
											hideEntries={false}
											showNumeration={false}
											customFilters={
												<div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
													<Label>{'Sort by:'.translate(this.props.lang)}</Label>
													<Input
														type='select'
														value={this.state.sortField}
														className="schedule-container-input"
														onChange={(e) => this.setState({ sortField: e?.target?.value })}>

														<option value={'initialCreatedAt'}>{'Created at'.translate(this.props.lang)}</option>
														<option value={'doctorData.doctorName'}>{'Doctor name'.translate(this.props.lang)}</option>
														<option value={'templateData.templateName'}>{'Template name'.translate(this.props.lang)}</option>
														{/* <option value={'templateData.templateType'}>{'Template type'.translate(this.props.lang)}</option> */}

													</Input>
												</div>
											}
											fields={[

												{
													type: 'text',
													name: 'templateName',
													label: '',

												},
												// {
												// 	type: 'text',
												// 	name: 'templateNamea',
												// 	label: 'Template name'.translate(this.props.lang)
												// },
												// {
												// 	type: 'text',
												// 	name: 'initialddCreatedAta',
												// 	label: 'Created at'.translate(this.props.lang),
												// },
											]}
											allowRowClick={true}
											onClick={async (item) => {
												await this.openJournalNote(item);
											}}

											// onClick={async (item) => {
											// 	if (this.wholeRowClickable === false) return;

											// 	if ((this.state.journalFormBuilder && this.state.journalFormBuilder._id === item._id) || this.state.journalFormBuilderNew) {
											// 		if (!this.state.isJournalNoteActive) {
											// 			this.setState({
											// 				journalFormBuilder: null,
											// 				journalFormBuilderNew: null
											// 			})
											// 			return;
											// 		} else {
											// 			this.setState({
											// 				isJournalNoteActiveChange: 'close journal note iframe'
											// 			})
											// 			return;
											// 		}

											// 	}
											// 	const { data: tokenData } = await this.getJournalSSOToken("notes");

											// 	if (!tokenData?.data?.token) return;

											// 	this.setState({ journalSSOToken: tokenData.data.token });
											// 	this.setState({ journalFormBuilder: item, journalFormBuilderNew: null }, () => {
											// 		// odmah pošalji permissions nakon što je iframe postavljen
											// 		this.sendPermissionsToIframe();
											// 	});
											// }}
											items={this.state.journalNotes.map((item) => {
												return {
													...item,
													___className: this.state.journalFormBuilder && this.state.journalFormBuilder._id === item._id ? 'journal_note_active' : '',
													// templateName: <div>
													// 	<div>{item?.initialCreatedAt} {item?.templateData?.templateName}</div>
													// 	<div>{'Doctor'.translate(this.props.lang)}: {item?.doctorData?.doctorName}</div>
													// </div>
													templateName: <div className="visitCard">
														<div className="visitTitle">
															{item?.templateData?.templateName}
														</div>

														<div className="visitMeta">
															<span>{moment(item.initialCreatedAt).format('DD MMM YYYY • HH:mm')}</span>
															<span className="dot">•</span>
															<span>{item?.doctorData?.doctorName}</span>
														</div>
													</div>
												};
											})}
											actions={[
												{
													renderComponent: (item) => {
														return (
															item?.isDraft === true ? (
																<div className='tabel-action-tooltip'>
																	<Isvg src={deleteIcon} />
																	<div className='chat-icons-tooltip'>
																		{'Delete note'.translate(this.props.lang)}
																	</div>
																</div>
															) : (
																<>
																</>
															)
														);
													},
													onClick: async (item) => {
														this.wholeRowClickable = false;
														setTimeout(() => {
															this.wholeRowClickable = true;
														}, 500);
														const { data: tokenData } = await this.getJournalSSOToken("notes");
														if (!tokenData?.data?.token) return;

														this.setState({
															journalSSOToken: tokenData.data.token,
															journalDeleteNoteModal: item
														});
													},
													condition: (item) => {
														if (item?.doctorData?.doctorId === this.props.uData?.journalCuroflow?.[this.props.selectedGroup]?.id) {
															return true;
														} else {
															return false;
														}
													}
												},
												{
													renderComponent: (item) => {
														return (
															<div className='tabel-action-tooltip'>
																<Isvg src={copyIcon} />
																<div className='chat-icons-tooltip'>
																	{'Copy to new note'.translate(this.props.lang)}
																</div>
															</div>
														);
													},
													onClick: (item) => {
														this.wholeRowClickable = false;
														setTimeout(() => {
															this.wholeRowClickable = true;
														}, 500);
														this.setState({ infoCopyModal: item });
													},
													condition: (item) => {
														if (item?.doctorData?.doctorId === this.props.uData?.journalCuroflow?.[this.props.selectedGroup]?.id) {
															return true;
														} else {
															return false;
														}
													}
												},
												{
													renderComponent: (item) => {
														// let disableEdit = this.checkDisableEdit(item);
														let allowEdit = item?.isSigned?.status === false && item?.doctorData?.doctorId === this.props.uData?.journalCuroflow?.[this.props.selectedGroup]?.id && this.state.clinicUserPermissions?.write?.journal_notes === true;

														return (
															<div className='tabel-action-tooltip'>
																{!allowEdit ? <Isvg src={viewIcon} /> : <Isvg src={editIcon} />}
																<div className='chat-icons-tooltip'>
																	{!allowEdit
																		? 'View'.translate(this.props.lang)
																		: 'Edit'.translate(this.props.lang)}
																</div>
															</div>
														);
													},
													onClick: async (item) => {
														this.wholeRowClickable = false;
														setTimeout(() => {
															this.wholeRowClickable = true;
														}, 500);
														const { data: tokenData } = await this.getJournalSSOToken("notes");
														if (!tokenData?.data?.token) return;

														this.setState({ journalSSOToken: tokenData.data.token });
														this.setState({ journalFormBuilder: item, journalFormBuilderNew: null }, () => {
															// odmah pošalji permissions nakon što je iframe postavljen
															this.sendPermissionsToIframe();
														});
													},
													// condition: (item) => {
													// 	let disableEdit = this.checkDisableEdit(item);

													// 	if (!disableEdit) {
													// 		return true;
													// 	} else {
													// 		return false;
													// 	}
													// }
												},
												{
													renderComponent: (item) => {
														let disableEdit = this.checkDisableEdit(item, true);

														return (
															<div className={item?.isSigned?.status === false ? 'tabel-action-tooltip' : 'tabel-action-tooltip svg-sign'}>
																{' '}
																<Isvg width={20} height={20} src={LockIcon} />{' '}
																<div className='chat-icons-tooltip'>
																	{item?.isSigned?.status === false ? 'Sign'.translate(this.props.lang) :
																		disableEdit ? 'Signed'.translate(this.props.lang) : 'Unlock'.translate(this.props.lang)}
																</div>{' '}
															</div>
														)
													},
													onClick: (item) => {
														this.wholeRowClickable = false;
														setTimeout(() => {
															this.wholeRowClickable = true;
														}, 500);
														let disableEdit = this.checkDisableEdit(item, true);

														if (item?.isSigned?.status === false) this.setState({ infoSignModal: item })
														else if (disableEdit === false) this.setState({ infoUnsignModal: item })

													},
													condition: (item) => {
														if ((item?.isSigned?.status === false && item?.doctorData?.doctorId === this.props.uData?.journalCuroflow?.[this.props.selectedGroup]?.id) || item?.isSigned?.status === true) {
															return true;
														} else {
															return false;
														}
													}
												},
												{
													component: (
														<div className='tabel-action-tooltip'>
															{' '}
															<Isvg width={20} height={20} src={pdfIcon} />{' '}
															<div className='chat-icons-tooltip'>
																{'Save as pdf'.translate(this.props.lang)}
															</div>{' '}
														</div>
													),
													onClick: async (item) => {
														this.wholeRowClickable = false;
														setTimeout(() => {
															this.wholeRowClickable = true;
														}, 500);
														const response = await fetch(`${API_ENDPOINT}/users/users/patient/journalNotes/pdf`, {
															method: 'post',
															headers: {
																'Content-Type': 'application/json',
																Authorization: `Bearer ${localStorage.getItem('authToken')}`,
															},
															body: JSON.stringify({ groupId: this.props.selectedGroup || null, id: item?._id, patientId: this.props.patientId, lang: this.props?.lang || "en" }),
															responseType: 'blob'
														})

														const blob = await response.blob();

														const url = window.URL.createObjectURL(blob);
														window.open(url, '_blank');

														setTimeout(() => window.URL.revokeObjectURL(url), 10000);
													},
												},
											]}
											rawItems={this.state.items}
											params={params}
											sortField={params.sortField}
											sortType={params.sortType}
											updateSort={this.updateSort}
											updateParams={this.updateParams}
											updateMultipleParams={this.updateMultipleParams}
										></ListBuilder>
									</Col>
								</Row>

							</Col>
						}
						{
							this.state.tabIndex == 2 ?
								<Col lg='12'>
									<div className="panel" style={{ padding: 0 }}>
										<HealthFlagsTab
											{...this.props}
										/>
									</div>
								</Col>
								:
								null
						}

						{
							this.state.tabIndex == 3 && this.state.clinicUserPermissions?.read?.patient_vital_logs ?
								<Col lg='12'>
									<div className="panel" style={{ padding: 0 }}>
										<VitalLogsTab
											{...this.props}

										/>
									</div>
								</Col>
								:
								null
						}
						{
							this.state.tabIndex == 4 && this.state.clinicUserPermissions?.read?.patient_vaccination ?
								<Col lg='12'>
									<div className="panel" style={{ padding: 0 }}>
										<VaccinationsTab
											{...this.props}

										/>
									</div>
								</Col>
								:
								null
						}

						{
							this.state.tabIndex == 5 && this.state.clinicUserPermissions?.read?.patient_previous_records ?
								<Col lg='12'>
									<div className="panel" style={{ padding: 0, paddingTop: '10px' }}>
										<PatientPreviousRecordsTab
											{...this.props}

										/>
									</div>
								</Col>
								:
								null
						}
					</Row>
				</Container>

				{/* Preview for journal form builder */}
				{/* <PreviewModal
					lang={this.props.lang}
					isOpen={this.state.journalFormBuilder}
					toggle={() => this.closeModal()}
					className={"modal-xxxl"}
				>

					{this.state.journalFormBuilder?._id && (
						<iframe
							id="journalNotesTabIframe"
							src={`${JOURNAL_DASHBOARD}/journal/templates/builder/${this.state.journalFormBuilder?.templateData?.templateId}/${this.state.journalFormBuilder?._id}`}
							style={{ width: '100%', height: '1000px', border: '1px solid #fff' }}
						/>
					)}

				</PreviewModal> */}

				{this.state.journalTemplatesModal && (
					<JournalTemplatesModal onSelect={async (data) => {
						const { data: tokenData } = await this.getJournalSSOToken("templates");
						if (!tokenData?.data?.token) return;

						this.setState({ journalSSOToken: tokenData.data.token });

						this.setState({
							journalFormBuilderNew: data,
							journalFormBuilder: null,
						}), () => {
							this.sendPermissionsToIframe();
						}
					}} {...this.props} isOpen={this.state.journalTemplatesModal} closeModal={() => {
						// this.setState({ journalTemplatesModal: false });
						this.closeModal()
					}} />
				)}

				<PreviewModal
					lang={this.props.lang}
					isOpen={this.state.pdfModal}
					toggle={() => this.closeModal()}
					className={"modal-lg"}
					pdfUrl={this.state?.pdfLink}
				>
					<JournalPdf pdfUrl={this.state?.pdfLink} />
				</PreviewModal>

				{
					this.state.journalDeleteNoteModal ? <Modal isOpen={this.state.journalDeleteNoteModal} centered toggle={() => this.setState({ journalDeleteNoteModal: null })}>
						<ModalBody className="delete-modal">
							<p className="message">{`Are you sure you want to delete this note?`.translate(this.props.lang)}</p>
						</ModalBody>

						<ModalFooter className='buttons-right-blue'>
							<button style={{ visibility: 'hidden', display: 'none' }} aria-hidden='true'></button>
							<Button style={{ minWidth: 100 }} color='danger'
								onClick={async () => {
									await this.deleteJournalNote(this.state.journalDeleteNoteModal?._id, this.state.journalDeleteNoteModal?.referralIdV1 || null)
									this.closeModal();
								}}>{'Delete'.translate(this.props.lang)}</Button>
							<Button style={{ minWidth: 100 }} color='primary' onClick={() => this.setState({ journalDeleteNoteModal: null })}>{'Close'.translate(this.props.lang)}</Button>
						</ModalFooter>
					</Modal> : null
				}

				{
					this.state.infoSignModal ?
						// <InfoModal
						// 	isOpen={this.state.infoSignModal}
						// 	onClose={() => {
						// 		this.setState({
						// 			infoSignModal: false
						// 		})
						// 	}}
						// 	header={'Confirm Journal Note Signature'.translate(this.props.lang)}
						// 	info={'Signing will publish and lock this note. Signed notes cannot be deleted. To edit, you must un-sign it first.'.translate(this.props.lang)}
						// 	buttons={[
						// 		<Button color="primary" style={{ margin: 10 }}
						// 			onClick={async () => {
						// 				await this.signJournalNote(this.state.infoSignModal, true)
						// 				await this.get();
						// 				this.closeModal();
						// 			}}>{'Sign'.translate(this.props.lang)}</Button>,
						// 		<Button color="primary" style={{ margin: 10 }} onClick={() => this.setState({ infoSignModal: false })}>{'Cancel'.translate(this.props.lang)}</Button>


						// 	]}
						// />
						<Modal isOpen={this.state.infoSignModal} centered>
							<ModalBody>
								<p>{'Signing will publish and lock this note. Signed notes cannot be deleted. To edit, you must un-sign it first.'.translate(this.props.lang)}</p>
								{
									this.state.infoSignModal?.notesHistory?.length > 1 ? null :
										<div className="form-questions-builder__questions-header-date-datetime-wrap">
											<label>{"Signing date".translate(this.props.lang)}:</label>
											<input
												type="datetime-local"
												value={this.state.journalDate ?? this.formatJournalNoteDateTimeLocal(this.state.infoSignModal?.initialCreatedAt)}
												onChange={(e) => {
													this.setState({
														journalDate: e.target.value
													})
												}}
												className="sign-note-modal__questions-header-date-datetime-input"
											/>
										</div>
								}



							</ModalBody>
							<ModalFooter className='buttons-right-blue'>
								<Button color='primary' onClick={() => this.setState({ infoSignModal: null })}>{'Cancel'.translate(this.props.lang)}</Button>
								<Button color='primary' onClick={async () => {
									await this.signJournalNote(this.state.infoSignModal, true)
									await this.get();
									this.closeModal();
								}}>{'Sign note'.translate(this.props.lang)}</Button>
							</ModalFooter>
						</Modal>
						:
						null
				}
				{
					this.state.infoCopyModal ?
						<InfoModal
							isOpen={this.state.infoCopyModal}
							onClose={() => {
								this.setState({
									infoCopyModal: false
								})
							}}
							// header={'Confirm Journal Note Signature'.translate(this.props.lang)}
							info={<>
								<div style={{ display: 'flex', flexDirection: 'column', gap: 20, textAlign: 'left' }}>
									<div >{'Copy to new:'.translate(this.props.lang)}</div>

									<div>{'A new journal entry will be created.Journal text from this entry will be copied to the new entry.'.translate(this.props.lang)}</div>

									<div >{'Do you want to continue?'.translate(this.props.lang)}</div>
								</div>
							</>}
							buttons={[
								<Button color="primary" style={{ margin: 10 }}
									onClick={async () => {
										const { data: tokenData } = await this.getJournalSSOToken("notes");
										if (!tokenData?.data?.token) return;

										this.setState({ journalSSOToken: tokenData.data.token });
										const data = await this.copyJournalNote(this.state.infoCopyModal?._id || this.state.infoCopyModal?.id);
										await this.get();
										this.setState({ journalFormBuilder: data, infoCopyModal: false });
									}}>{'Yes'.translate(this.props.lang)}</Button>,
								<Button color="primary" style={{ margin: 10 }} onClick={() => this.setState({ infoCopyModal: false })}>{'No'.translate(this.props.lang)}</Button>


							]}
						/>
						:
						null
				}

				{
					this.state.infoUnsignModal ?
						<InfoModal
							isOpen={this.state.infoUnsignModal}
							onClose={() => {
								this.setState({
									infoUnsignModal: false
								})
							}}
							header={'Confirm Journal Note Unlock'.translate(this.props.lang)}
							info={'Do you want to unlock this note?'.translate(this.props.lang)}
							buttons={[
								<Button color="primary" style={{ margin: 10 }}
									onClick={async () => {
										const itemToOpen = this.state.infoUnsignModal;
										await this.signJournalNote(this.state.infoUnsignModal, false)
										await this.get();
										await this.openJournalNote(itemToOpen)
										// this.closeModal();
									}}>{'Unlock'.translate(this.props.lang)}</Button>,
								<Button color="primary" style={{ margin: 10 }} onClick={() => this.setState({ infoUnsignModal: false })}>{'Cancel'.translate(this.props.lang)}</Button>


							]}
						/>
						:
						null
				}

				{
					this.state.createPaymentModal ?
						<CreatePayment
							{...this.props}
							hideSelectPatient={true}
							patientId={this.props.patientId}
							isOpen={this.state.createPaymentModal}
							onClose={(callback) => {
								this.setState({ createPaymentModal: false }, () => {
									if (callback) callback();
								});
							}}
						/>
						:
						null
				}

				{
					this.state.error ?
						<ErrorModal
							isOpen={this.state.error ? true : false}
							toggle={() => this.setState({ error: null })}
						>
							{
								this.state.error.translate(this.props.lang)
							}
						</ErrorModal>
						:
						null
				}

				{
					this.state.isJournalNoteActiveChange ?
						<Modal isOpen={this.state.isJournalNoteActiveChange} centered>
							<ModalBody className="delete-modal">
								<p className="message">{'You have unfinished clinical note. If you continue your changes will be lost.'.translate(this.props.lang)}</p>
							</ModalBody>
							<ModalFooter className='buttons-right-blue'>

								<Button color="primary" style={{ margin: 10, minWidth: 100 }} onClick={() => {

									if (this.state.isJournalNoteActiveChange === 'see payments') {
										this.props[0].history.push(`/my-data/clinic/payments?entries=10&sortField=timestamp&sortType=-1&filter=${this.state.patient.socialSecurityNumber}`)
									} else if (this.state.isJournalNoteActiveChange === 'start video call') {
										this.props.startVideoCallHandler();
									} else if (this.state.isJournalNoteActiveChange === 'tab 1') {
										this.setState({ tabIndex: 1 }, () => {
											this.get();
											this.setState({
												journalFormBuilder: null,
												journalFormBuilderNew: null
											})
										})
									} else if (this.state.isJournalNoteActiveChange === 'tab 2') {
										this.setState({ tabIndex: 2 })
									} else if (this.state.isJournalNoteActiveChange === 'tab 3') {
										this.setState({ tabIndex: 3 })
									} else if (this.state.isJournalNoteActiveChange === 'tab 4') {
										this.setState({ tabIndex: 4 })
									} else if (this.state.isJournalNoteActiveChange === 'new clinical note') {
										this.setState({
											journalTemplatesModal: true,
											journalFormBuilderNew: true,
											journalFormBuilder: null
										}, () => {
											this.sendPermissionsToIframe();
										});
									} else if (this.state.isJournalNoteActiveChange === 'close journal note iframe') {
										this.setState({
											journalFormBuilder: null,
											journalFormBuilderNew: null
										})
									}

									this.props.abortAction()

									this.setState({
										isJournalNoteActiveChange: false,
										EHR_noteEditedButNotSaved: false
									})


								}}>{'Exit without saving'.translate(this.props.lang)}</Button>
								<Button color="primary" style={{ margin: 10, minWidth: 100 }} onClick={() => {
									this.setState({
										isJournalNoteActiveChange: false
									})
									// this.props.abortAction()
									// this.props.groupSettingsChanged()

								}}>{'Cancel'.translate(this.props.lang)}</Button>

							</ModalFooter>
						</Modal>
						: null
				}
			</div>
		)
	}
}